import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["aria-label", "data-testid"]
const _hoisted_2 = ["aria-checked", "tabindex", "disabled", "data-testid", "onClick", "onKeydown"]

import { computed, nextTick, ref } from 'vue'

export type SegmentedOption = { value: string; label: string; disabled?: boolean }


export default /*#__PURE__*/_defineComponent({
  __name: 'SegmentedControl',
  props: {
    modelValue: {},
    options: {},
    ariaLabel: {},
    size: { default: 'md' },
    testId: { default: 'segmented-control' }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }) {

const props = __props;



const buttons = ref<HTMLButtonElement[]>([])

/** Roving tabindex: o escolhido (ou o 1º habilitado) recebe o Tab. */
const focusValue = computed(() => {
  const selected = props.options.find((o) => o.value === props.modelValue && !o.disabled)
  return (selected ?? props.options.find((o) => !o.disabled))?.value
})

function select(option: SegmentedOption): void {
  if (option.disabled || option.value === props.modelValue) return
  emit('update:modelValue', option.value)
}

function enabledIndexFrom(start: number, step: 1 | -1): number {
  const total = props.options.length
  for (let i = 1; i <= total; i += 1) {
    const index = (start + step * i + total) % total
    if (!props.options[index].disabled) return index
  }
  return start
}

async function moveTo(index: number): Promise<void> {
  const option = props.options[index]
  if (!option || option.disabled) return
  // Radio: a seta escolhe e move o foco (WAI-ARIA radiogroup).
  emit('update:modelValue', option.value)
  await nextTick()
  buttons.value[index]?.focus()
}

function onKeydown(event: KeyboardEvent, index: number): void {
  const firstEnabled = props.options.findIndex((o) => !o.disabled)
  const lastEnabled =
    props.options.length - 1 - [...props.options].reverse().findIndex((o) => !o.disabled)
  const next: Record<string, number> = {
    ArrowRight: enabledIndexFrom(index, 1),
    ArrowDown: enabledIndexFrom(index, 1),
    ArrowLeft: enabledIndexFrom(index, -1),
    ArrowUp: enabledIndexFrom(index, -1),
    Home: firstEnabled,
    End: lastEnabled
  }
  if (!(event.key in next)) return
  event.preventDefault()
  void moveTo(next[event.key])
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    role: "radiogroup",
    "aria-label": _ctx.ariaLabel,
    class: _normalizeClass(["flex max-w-full items-stretch gap-[2px] overflow-x-auto rounded-lg bg-gray-100 px-[3px]", _ctx.size === 'sm' ? 'h-8' : 'h-10']),
    "data-testid": _ctx.testId
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option, index) => {
      return (_openBlock(), _createElementBlock("button", {
        key: option.value,
        ref_for: true,
        ref_key: "buttons",
        ref: buttons,
        type: "button",
        role: "radio",
        class: _normalizeClass(["group flex shrink-0 items-stretch py-[3px] outline-none disabled:cursor-not-allowed disabled:opacity-40", _ctx.size === 'sm' ? 'h-full' : 'min-h-[40px]']),
        "aria-checked": option.value === _ctx.modelValue,
        tabindex: option.value === focusValue.value ? 0 : -1,
        disabled: option.disabled,
        "data-testid": `${_ctx.testId}-${option.value}`,
        onClick: ($event: any) => (select(option)),
        onKeydown: ($event: any) => (onKeydown($event, index))
      }, [
        _createElementVNode("span", {
          class: _normalizeClass(["flex items-center whitespace-nowrap rounded-md px-3 text-sm transition-colors group-focus-visible:ring-2 group-focus-visible:ring-inset group-focus-visible:ring-primary30", 
          option.value === _ctx.modelValue
            ? 'bg-white font-semibold text-primary30 shadow-sm'
            : 'text-gray-600'
        ])
        }, _toDisplayString(option.label), 3)
      ], 42, _hoisted_2))
    }), 128))
  ], 10, _hoisted_1))
}
}

})